<div class="container py-4">
  <h2>ALPHANAPSIS®</h2>
  <div class="row g-3 mt-2">
    <div class="col-md-4" *ngFor="let s of lines">
      <a class="card h-100 p-3" [routerLink]="['/software', s.slug]">

        <img [src]="s.logo" width="180px">
        <br>

        <h5>{{ s.name }}</h5>
        <p class="text-secondary">{{ s.summary }}</p>
      </a>
    </div>
  </div>
</div>
